export default {
  RESERVATION_TITLE_RENDERED: 'RESERVATION_TITLE_RENDERED',
  RESERVATION_DESC_RENDERED: 'RESERVATION_DESC_RENDERED',
  RESERVATION_CONTENT_RENDERED: 'RESERVATION_CONTENT_RENDERED',
  RESERVATION_IFRAME_RENDERED: 'RESERVATION_IFRAME_RENDERED',
  RESERVATION_MESSAGE_RENDERED: 'RESERVATION_MESSAGE_RENDERED',
  RESERVATION_MOBILE_STATIC: 'RESERVATION_MOBILE_STATIC',
  RESERVATION_LAYOUT_STATIC: 'RESERVATION_LAYOUT_STATIC'
};
